export default {"src":"/_next/static/media/pending-red.2031d74d.svg","height":73,"width":65,"blurWidth":0,"blurHeight":0};